export { NotFoundPage, MobileNotFoundPage } from './ui/not-found'
export { ErrorPage, MobileErrorPage } from './ui/error'
